import { apiClient } from './client'

export type ModelCost = {
  id: string
  name: string
  key: string
  inputCostPerMillion: number
  outputCostPerMillion: number
  createdAt: string
  updatedAt?: string
}

export type ModelCostPayload = {
  name: string
  key: string
  inputCostPerMillion: number
  outputCostPerMillion: number
}

export async function getModelCosts() {
  const { data } = await apiClient.get<ModelCost[]>('/api/admin/model-costs')
  return data
}

export async function createModelCost(payload: ModelCostPayload) {
  const { data } = await apiClient.post<ModelCost>('/api/admin/model-costs', payload)
  return data
}

export async function updateModelCost(id: string, payload: ModelCostPayload) {
  const { data } = await apiClient.put<ModelCost>(`/api/admin/model-costs/${id}`, payload)
  return data
}

export async function deleteModelCost(id: string) {
  await apiClient.delete(`/api/admin/model-costs/${id}`)
}
